<template>
  <div class="record-center">
    <heads ></heads>
    <div class="record-item">
      <div class="record-top">
        <div class="record-nav">
          <span class="record-nav-icon icon-SLOT"></span>
        </div>
      </div>
      <div class="record-item-list">
        <div class="record-item-top">
          <div class="record-item-time" :class="{'recordColor':type=='1'}" @click.stop="_check_week(1)">Daily</div>
          <div class="record-item-time" :class="{'recordColor':type=='2'}" @click.stop="_check_week(2)">Weekly</div>
          <div class="record-item-time" :class="{'recordColor':type=='3'}" @click.stop="_check_week(3)">Monthly</div>
        </div>
        <div class="item-padding" v-if="type==1 || type==2">
          <div class="item-list">

            <div class="item-list-center"  v-for="(item,index) in list"  @click.stop="_replay_day(item.id)">
              <div class="item-list-name">
                <div class="item-list-first" :class="[parseFloat(item.ranking)<=3?'item-list_no'+item.ranking:'item-list_no4']">{{ item.ranking }}</div>
                <div class="item-list-title">  {{ item.username }}</div>
              </div>
              <div class="item-list-name2 item-list-color">
                {{item.platform_abbr}}
              </div>
              <div class="item-list-name2">
                <div class="item-list-amount">
                  <div>{{$t('login.amount')}} {{item.win}}</div>
                  <div>Replay</div>
                </div>
              </div>
            </div>
          </div>

          <div class="item-week" v-if="type==4">
            <div class="item-week-left" v-for="(item,index) in list_week_title ">
              <div class="item-week-item">
                <div>Week</div>
                <div><span v-if="item!=0">{{ item}}</span><span v-else>-</span></div>
              </div>
            </div>
          </div>

        </div>

        <div class="item-padding" v-else-if="type==3">
          <div class="item-list">
            <div class="item-list-center" v-for="(item,index) in list">
              <div class="item-list-name" style="width: 80%">
                <div class="item-list-first" :class="[parseFloat(item.ranking)<=3?'item-list_no'+item.ranking:'item-list_no4']">{{ item.ranking }}</div>
                <div class="item-list-title">  {{ item.username }}</div>
              </div>
              <div class="item-month-count">{{item.win_count}}</div>
            </div>
          </div>
        </div>





      </div>
    </div>




    <div class="bet-cover" v-if="isDetail">
      <div class="bet-cover-center">
        <div class="bet-cover-title">{{$t('playerRankRecord.t_1')}}<span class="bet-cover-close" @click.stop="_hideDet"><img src="../assets/img/close.png"/></span></div>
        <div class="bet-cover-main">
          <div class="bet-main-cover" v-html="typeHtml"></div>
        </div>
      </div>
    </div>

    <div class="bet-cover" v-if="is_cover_week">
      <div class="bet-cover-week">
        <div class="bet-cover-week-top">
          <i class="icon icon-close"></i>
        </div>
        <div class="cover-week" v-for="(item,index) in cover_week"  @click.stop="_replay_day(item.id)">
          <div class="cover-week-title">
            <div class="item-list-first" :class="[parseFloat(item.ranking)<=3?'item-list_no'+item.ranking:'item-list_no4']">{{ item.ranking }}</div>
            <div class="item-list-title">  {{ item.username }}</div>
            <div class="cover-week-time">{{item.bet_time}}</div>
          </div>
          <div class="cover-week-title">
            <div class="cover-week-item item-list-color">
              {{item.platform_abbr}}
            </div>
            <div class="cover-week-item">
              <span class="cover-week-amount">{{$t('login.amount')}} {{item.win}}</span>
              <span class="cover-week-right">Replay</span>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import heads from "./navs/headr.vue";

export default {
  name: "playerRankRecord",
  components: {heads},
  data(){
    return{
      list:[
        /*{'username':'TEST1001','ranking':'1','win_count':'6','bet_time':'2024-01-13 00:53:09','win':'3490','platform_abbr':'JDB'},
        {'username':'TEST1001','ranking':'1','win_count':'6','bet_time':'2024-01-13 00:53:09','win':'3490','platform_abbr':'JDB'},
        {'username':'TEST1001','ranking':'1','win_count':'6','bet_time':'2024-01-13 00:53:09','win':'3490','platform_abbr':'JDB'},
        {'username':'TEST1001','ranking':'1','win_count':'6','bet_time':'2024-01-13 00:53:09','win':'3490','platform_abbr':'JDB'},
        {'username':'TEST1001','ranking':'1','win_count':'6','bet_time':'2024-01-13 00:53:09','win':'3490','platform_abbr':'JDB'},*/
      ],
      cover_week:[],
      is_cover_week:false,
      typeHtml:'',
      isDetail:false,
      isClick:false,
      type:'1',
      list_week:[],
      list_week_title:[0,0,0,0],
      search_month:'',
      search_date:'',
      intervalId:null,
    }
  },
  created() {
    let _self=this;
    var data = new Date();
    var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
    var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
    _self.search_date= data.getFullYear() + "-" + month + "-" + date;
    _self.search_month=data.getFullYear() + "-" + month;
    if(_self.type==1){
      _self._query_by_day();
    }else if(_self.type=='2'){
      _self._query_by_week();
    }else if(_self.type==3){
      _self._query_by_month();
    }
    let token=_self.GLOBAL.fetch('token');
    if(token.length!=0){
     _self.dataRefreh();

    }else{
      _self.clear();

    }

  },
  destroyed(){
    // 在页面销毁后，清除计时器
    this.clear();
  },
  methods:{
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.list=[];
        if(this.type==1){
          this._query_by_day();
        }else if(this.type=='2'){
          this.list_week_title=[0,0,0,0]
          this._query_by_week();
        }else if(this.type==3){
          this._query_by_month();
        }
      }, 300000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    _check_week:function (m){
      let _self=this;
      _self.list=[];
      _self.list_week_title=[0,0,0,0]
      _self.type=m;
      if(m==1){
        _self._query_by_day();
      }else if(m==2){
        _self._query_by_week();
      }else if(m==3){
        _self._query_by_month();
      }
    },
    _query_by_month:function (){
      let that=this;
      this._PublicFun.getData('2', 'get', 'win_top/query_by_month?search_month='+that.search_month, {}, function (result) {
        if (result.data['status_code'] == 200) {
          that.list=result.data['data'];

        }else{
          that.clear();
        }
      })
    },
    _query_by_week:function (){
      let that=this;
      let token=that.GLOBAL.fetch('token');
      if(token.length!=0){
        this._PublicFun.getData('2', 'get', 'win_top/query_by_week?search_month='+that.search_month, {}, function (result) {
          if (result.data['status_code'] == 200) {
            /*_self.list=result.data['data'];*/
            /*console.log(result.data['data']);*/
            let list=result.data['data'];
            that.list_week=list;
            for(var i in list){
              if(list[i].is_current_week==1){
                that.list=list[i].week_rank;
              }
            }

          }else{
            that.clear();
          }
        })
      }

    },
    _hideDet:function(){
      let _self=this;
      _self.typeHtml='';
      _self.isDetail=false;

    },
    _query_by_day:function (){
      let _self=this;
      this._PublicFun.getData('2', 'get', 'win_top/query_by_day?search_date='+_self.search_date, {}, function (result) {
        if (result.data['status_code'] == 200) {
          _self.list=result.data['data'];

        }else{
          _self.clear();
        }
      })

    },
    _replay_day:function (id){
      let _self=this;

      if(_self.isClick)
        return false;
      _self.isClick=true;
      this._PublicFun.getData('2', 'get', 'win_top_replay/'+id, {}, function (result) {
        if (result.data['status_code'] == 200) {
          let results=result.data['data'];
          if(results.type=='external_link'){
            window.open(results.data.url);
          }else if(results.type=='html'){
            _self.typeHtml=results.data;
            _self.isDetail=true;
          }
          _self.isClick=false;

        }else{
          _self.isClick=false;
          Toast(result.data['message']);
        }
      })
    }
  }
}
</script>



<style scoped>

.record-center{
  position: absolute;
  top: 45px;
  left: 0;
  width: 100%;
  bottom: 0;
  overflow-y: auto;
  margin: 0 auto;
  z-index: 2;
  background-color: #0c151d;
}
.record-item{
  display: block;
  width: 95%;
  margin: 0 auto;
  padding: 0;
  max-width: 720px;
}
.record-top{
  display: block;
  width: 100%;
  margin: 10px auto 0;
  padding: 0;
  background-color: #313539;
  border-bottom: 1px solid #8459d3;
  border-radius: 12px 12px 0 0;
  position: relative;

}
.record-nav{
  position: relative;
  height: 35px;
  padding: 0;
  margin: 0 auto;
  border-radius: 8px 8px 0 0;
  background-image: linear-gradient(to bottom, #2d6b8f, #8459d3);
  width: 50%;
  display: flex;
  align-items: center;
  color: #fff;
}
.record-nav-icon{
  font-size: 25px;
  margin-left: 10px;
  position: relative;
}
.record-nav-icon:before{
  content: '\e96a';
}
.record-item-list{
  display: block;
  margin: 0 auto;
  border-radius: 0 0 15px 15px;
  width: 100%;
  background-color: #00000065;
  padding: 0 5px 5px 5px;
  position: relative;

}
.record-item-list:before{
  position: absolute;
  left: 0;
  content: '';
  width: 100%;
  height: 100%;
  background: url('../assets/img/tournament-bg.png') no-repeat center 0px;
  background-size: 100%;
  background-position-y: -50px;
  pointer-events: none;
}
.record-item-top{
  display: flex;
  align-items: center;

  justify-content: center;
}
.record-item-time{
  display: block;
  min-width: 70px;
  line-height: 30px;
  padding: 0 10px 3px 10px;
  color: #ffffff9c;
  cursor: pointer;
  text-align: center;
  border-bottom: 2px solid #000000;
}
.recordColor{
  background-image: linear-gradient(rgba(132,89,211,0) 65%, rgba(132,89,211,0.564706));
  border-bottom: 2px solid #8459d3;
}
.item-padding{
  padding: 0 15px;
}
.item-list{
  display: block;
  width: 100%;
  margin: 0 auto;
  padding: 0;

}

.item-list-center{
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 0;
  margin: 0 auto;
  position: relative;
  cursor: pointer;
}
.item-list-center:nth-child(odd){
  background-color: #0f1c2995;
}
.item-list-center:nth-child(even){
  background-color: #00000040;
}
.item-list-name{
  display: flex;
  align-items: center;
  width: 50%;
  margin: 0;
  color: #829bb3;
  position: relative;
}
.item-list-name2{
  width: 25%;
  display: block;
  color: #829bb3;
  text-align: center;
}
.item-list-color{
  font-weight: bold;
  font-size: 20px;
  color:#EAA71E !important;
  text-shadow:
    0px 1px 0px #c0c0c0,
    0px 2px 0px #b0b0b0,
    0px 3px 0px #a0a0a0,
    0px 4px 0px #909090,
    0px 5px 10px rgba(0, 0, 0, 0.6);
}
.item-list-first{
  display: block;
  width: 25px;
  height: 40px;
  position: relative;
  margin: 0 10px 0 5px;

}
.item-list-title{
  display: block;
  position: absolute;
  top: 50%;
  left: 35px;
  right: 0;
  transform: translateY(-50%);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.item-list_no1{
  color: transparent;
  background: url(../assets/img/01.png) no-repeat center center;
  background-size: 100%;
}
.item-list_no2{
  color: transparent;
  background: url(../assets/img/02.png) no-repeat center center;
  background-size: 100%;
}
.item-list_no3{
  color: transparent;
  background: url(../assets/img/03.png) no-repeat center center;
  background-size: 100%;
}
.item-list_no4{
  background: url(../assets/img/trophy-other.png) no-repeat center center;
  background-size: 100%;
  text-shadow: 0 1px 2px #373737;
  font-size: 14px;
  text-align: center;
  font-style: italic;
  color: #FFFFFF;
  line-height: 32px;
}
.item-list-icon{
  display: block;
  width: 35px;
  height: auto;
  margin: 0 10px;
  border-radius: 10px;
}
.item-list-amount{
  display: block;
  width: 100%;
  pointer-events: none;
  text-align: right;
}
.item-list-amount div{
  display: block;

}
.item-list-amount div:last-child{
  background-color: #b4d1ec;
  padding: 2px 5px !important;
  border-radius: 25px;
  margin-top: 5px;
  float: right;
  text-align: center;
  width: 45px;
  font-size: xx-small;
}
.item-week{
  display: inline-block;
  width: 90%;
  margin: 0 5%;
  padding: 0;
  clear: both;
}
.item-week-left{
  display: block;
  width: 50%;
  margin: 20px 0;
  padding: 0;
  float: left;
}
.item-week-item{
  display: block;
  width: 80%;

  max-width: 100px;
  text-align: center;
  color: #527a9f;
  background-color: #101a23;
  border: 1px solid #2b3f52;
  border-radius: 15px;
  line-height: 20px;
  box-shadow: 0 1px 3px #00000079;
  opacity: 0.6;
  padding: 2px;
}
.item-week-item div:last-child{
  color: #fff;
}
.item-month-count{
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background-color: #2bb128;
  padding: 1px 5px;
  border-radius: 100px;
  color: #FFFFFF;
}
.bet-cover{
  position: fixed;
  z-index: 99;
  left: 0;
  width: 100%;
  bottom: 0;
  top: 0;
  background-color: rgba(0,0,0,0.3);
}
.bet-cover-center{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #ffffff;
  border-radius: 5px;
  width: 85%;
  height: 80%;
}
.bet-cover-title{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border-bottom: 1px solid #dcdcdc;
}
.bet-cover-close{
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

}
.bet-cover-close img{
  width: 30px;
  height: auto;
}
.bet-cover-main{
  position: absolute;
  top: 45px;
  left: 0;
  width: 100%;
  bottom: 0;
  overflow-y: auto;
}
.bet-main-cover{
  display: block;
  width: 100%;
  margin: 0 auto;
  padding: 0;
}
.bet-cover-week{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #152433;
  box-shadow:0 5px 10px #090e14;
  border: 4px solid #28394b;
  width: 90%;
  max-width: 450px;
  border-radius: 15px;
  overflow-y: auto;

}
.bet-cover-week-top{
  display: block;
  width: 100%;
  margin: 0 auto;
  height: 40px;
  position: relative;
}
.cover-week{
  display: block;
  width: 100%;
  margin: 0 auto;
  padding:5px 0;
}
.cover-week:nth-child(even){
  background-color: #00000040;
}
.cover-week-title{
  display: flex;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  position: relative;
}
.cover-week-title .item-list-title{
  color: #829bb3;
}
.cover-week-time{
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #a2bed8;
  font-size: 12px;
}
.cover-week-item{
  display: block;
  width: 45%;
  margin: 0 auto;
  padding: 0;
  position: relative;
}
.cover-week-amount{
  color: #a2bed8;

}
.cover-week-right{
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #b4d1ec;
  padding: 2px 5px !important;
  border-radius: 25px;
  font-size: xx-small;
}

.icon-close{
  position: absolute;
  right: 10px;
  color: #c9c9c9;
  font-size:30px;
  font-weight: bold;
  line-height: 34px;
}
.icon-close:before{
  content: '\e914';
}

</style>



// WEBPACK FOOTER //
// src/components/playerRankRecord.vue